import script from "./CursorGrowing.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorGrowing.vue?vue&type=script&setup=true&lang=js"

import "./CursorGrowing.vue?vue&type=style&index=0&id=c21fb0fc&lang=scss"

const __exports__ = script;

export default __exports__